import { render } from "./BuilderSettings.vue?vue&type=template&id=ced267f6"
import script from "./BuilderSettings.vue?vue&type=script&lang=js"
export * from "./BuilderSettings.vue?vue&type=script&lang=js"

import exportComponent from "/home/builder/shared-storage/.project-directory/builder-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__